export const CMS_ACTIONS = {
  DATA_SAVED: 'CMS_ACTIONS/DATA_SAVED',
  ALL_DATA_SAVED: 'CMS_ACTIONS/ALL_DATA_SAVED',
  FETCH_DATA_CALL: 'CMS_ACTIONS/FETCH_DATA_CALL',
};
